"use client";

import { useEffect } from "react";
import type { Id } from "@convex/_generated/dataModel";
import { track } from "@/lib/analytics/tracker";
import { useListingActionSettled } from "./listing-action-resolution";

export type ClaimGate = "sign_in" | "setup" | "upgrade";

export function useClaimGateShown(
  productId: Id<"products">,
  gate: ClaimGate | null,
): void {
  const isSettled = useListingActionSettled();
  useEffect(() => {
    if (gate && isSettled) track("claim.gate_shown", { productId, gate });
  }, [productId, gate, isSettled]);
}
